<template>
    <div>
        <v-dialog v-model="value" persistent max-width="60%">
            <v-stepper v-model="e1" >
                <v-stepper-header>
                    <v-stepper-step :complete="e1 > 1" step="1">{{ $t('staff_management.user_infor')}}</v-stepper-step>
            
                    <v-divider></v-divider>
            
                    <v-stepper-step :complete="e1 > 2" step="2">{{ $t('staff_management.address_infor')}}</v-stepper-step>
                </v-stepper-header>
            
                <v-stepper-items>
                    <v-stepper-content step="1">
                        <v-container align="center" v-if="e1 === 1">
                            <v-row no-gutters>
                                <v-col cols="12" sm="6" class="pr-2">
                                    <v-text-field v-model="editedItem.fullname" :rules="stringRules" v-bind:label="$t('profile.fullname')" outlined dense></v-text-field>
                                </v-col>

                                <v-col cols="12" sm="6" class="pl-2">
                                    <v-text-field v-model="editedItem.phone" :rules="phoneRules" v-bind:label="$t('profile.phone')" outlined dense></v-text-field>
                                </v-col>
                            </v-row>

                            <v-row no-gutters>
                                <v-col cols="12" sm="6" class="pr-2">
                                    <v-text-field v-model="editedItem.email" :rules="emailRules" v-bind:label="$t('profile.email')" outlined dense></v-text-field>
                                </v-col>

                                <v-col cols="12" sm="6" class="pl-2">
                                    <v-text-field v-model="editedItem.nickname" :rules="stringRules" v-bind:label="$t('profile.nickname')" outlined dense></v-text-field>
                                </v-col>
                            </v-row >

                            <v-row no-gutters>
                                <v-col cols="12" sm="6" class="pr-2">
                                    <v-text-field v-model="editedItem.identify" :rules="identifyRules" v-bind:label="$t('profile.identify')" outlined dense></v-text-field>
                                </v-col>

                                <v-col cols="12" sm="6" class="pl-2">
                                    <v-dialog ref="dialog" v-model="modal" :return-value.sync="date" persistent width="290px">
                                        <template v-slot:activator="{ on }">
                                            <v-text-field v-model="computedDateFormatted" v-bind:label="$t('profile.birthday')" readonly v-on="on" outlined dense></v-text-field>
                                        </template>
                                        <v-date-picker v-model="date" scrollable locale="vi">
                                            <v-spacer></v-spacer>
                                            <v-btn text color="primary" @click="modal = false"> {{ $t('common.cancel') }} </v-btn>
                                            <v-btn text color="primary" @click="$refs.dialog.save(date)"> {{ $t('common.ok') }} </v-btn>
                                        </v-date-picker>
                                    </v-dialog>
                                </v-col>
                            </v-row>

                            <v-row v-show="editedIndex == -1" no-gutters>
                                <v-col cols="12" sm="6" class="pr-2">
                                    <v-text-field v-model="editedItem.password" :rules="passdRules" v-bind:label="$t('profile.password')" outlined :append-icon="show ? 'visibility' : 'visibility_off'" :type="show ? 'text' : 'password'" required @click:append="show = !show" dense></v-text-field>
                                </v-col>
                            </v-row>

                            <v-row no-gutters>
                                <v-col cols="12" sm="6">
                                    <v-autocomplete v-model="selectCategory" :items="categories" item-text="title" v-bind:label="$t('job_management.role')" return-object outlined dense></v-autocomplete>
                                </v-col>
                            </v-row>
                            <v-row no-gutters>
                                <v-col cols="12" sm="6">
                                    <v-autocomplete v-model="selectedJob" :items="jobs" item-text="title" v-bind:label="$t('job_management.context')" return-object outlined dense></v-autocomplete>
                                </v-col>
                            </v-row>
                            
                        </v-container>

                        <v-divider></v-divider>
                        <v-toolbar flat>
                            <v-btn color="primary" width="120px" @click="cancelAction" class="mr-5">{{ $t('common.cancel') }}</v-btn>
                            <v-spacer> </v-spacer>
                            <v-btn color="primary" @click="validateUserInfor" width="120px" class="mr-5">
                                {{ $t('common.continue') }}
                            </v-btn>
                        </v-toolbar>
                    </v-stepper-content>
            
                    <v-stepper-content step="2">
                        <v-container align="center" v-if="e1 === 2">
                            <v-row no-gutters>
                                <v-col cols="12" sm="6" class="pr-2">
                                    <v-autocomplete v-model="selectProvince" :items="provinces" item-text="province_name" v-bind:label="$t('profile.province')" outlined return-object dense></v-autocomplete>
                                </v-col>

                                <v-col cols="12" sm="6" class="pl-2">
                                    <v-autocomplete v-model="selectDistrict" :items="districts" item-text="district_name" v-bind:label="$t('profile.district')" outlined return-object dense></v-autocomplete>
                                </v-col>

                                <v-col cols="12" sm="6" class="pr-2">
                                    <v-autocomplete v-model="selectWard" :items="wards" item-text="wards_name" v-bind:label="$t('profile.ward')" outlined return-object dense></v-autocomplete>
                                </v-col>

                                <v-col cols="12" sm="6" class="pl-2">
                                    <v-text-field v-model="detail" :rules="addressRules" v-bind:label="$t('profile.address')" outlined dense></v-text-field>
                                </v-col>
                            </v-row>
                        
                        </v-container>

                        <v-divider></v-divider>
                        <v-toolbar flat>
                            <v-btn color="primary" width="120px" @click="back" class="mr-5">{{ $t('common.back') }}</v-btn>
                            <v-spacer> </v-spacer>
                            <v-btn color="primary" @click="validateAddressInfor" width="120px" class="mr-5">
                                {{ $t('common.save') }}
                            </v-btn>            
                        </v-toolbar>
                        
                    </v-stepper-content>
                </v-stepper-items>
            </v-stepper>

            <v-overlay :value="overlay" :z-index="0">
                <v-progress-circular indeterminate size="64"></v-progress-circular>
            </v-overlay>
        </v-dialog>
    </div>
</template>

<script>
    import i18n from '@/plugins/i18n';
    import moment from 'moment';

    export default {
        name: 'user-dialog',

        props: {
            value: Boolean,
            editedItem: Object,
            editedIndex: Number
        },


        data: ()=> ({
            e1: 1,
            date: '',
            modal: false,
            show: false,

            isAdmin: localStorage.getItem('isAdmin') === 'true' ? true : false,
            userCategory: parseInt(localStorage.getItem('category')),
            userType: localStorage.getItem('type'),

            dialog: false,
            overlay: false,
            isEdit: false,
            firstEdit: true,

            selectDistrict: null,
            selectProvince: null,
            selectWard: null,
            detail: '',

            provinces: [],
            districts: [],
            wards: [],

            selectedJob: null,
            categories: [],
            selectCategory: null,

            jobs: [],

            stringRules: [
                v => !!v || i18n.t('validate.not_empty'),
                //   v => (v && v.length > 3) || i18n.t('validate.string_invalid')
            ],
            identifyRules: [
                v => (v && v.length > 8) || i18n.t('validate.indentify_invalid')
            ],
            phoneRules: [
                v => !!v || i18n.t('validate.not_empty'),
                v => (v && v.length > 9) || i18n.t('validate.phone_invalid'),
            ],
            addressRules: [
                v => !!v || i18n.t('validate.not_empty'),
                // v => (v && v.length > 5) || i18n.t('validate.address_invalid'),
            ],
            emailRules: [
                v => !!v || i18n.t('validate.email_require'),
                v => /.+@.+\..+/.test(v) || i18n.t('validate.email_invalid'),
            ],
            passdRules: [
                v => !!v || i18n.t('validate.password_require'),
                v => (v && v.length > 5) || i18n.t('validate.password_invalid'),
            ]
        }),

        computed: {
            computedDateFormatted () {
                return this.formatDate(this.date)
            },
        },

        watch: {
            selectProvince (val) {
                if (!this.firstEdit) {
                    this.selectWard = null;
                }

                if (val && val.province_id) {
                    this.getDistrictByProvinceID(val.province_id);
                } 
            },

            selectDistrict (val) {
                if (val && val.district_id) {
                    this.getWardByDistrictID(val.district_id);
                }
            },

            selectCategory (val) {
                this.getJobByCategory(val);
            }
        },

        mounted() {
            
        },

        async created () {
            await this.getProvince(),
            await this.getAllCategory();

            if (this.editedIndex > -1) {
                this.isEdit = true;
                this.date = moment(String(this.editedItem.birthday)).format("YYYY-MM-DD");

                if (this.editedItem.job) {  
                    this.selectedJob = this.editedItem.job        
                    this.selectCategory =  this.categories.find(category => category.type === this.editedItem.job.category.type)
                    // this.getJobByCategory(this.selectCategory);
                }
                        
                if (this.editedItem.address && this.editedItem.address.ward) {
                    this.detail = this.editedItem.address.detail;
                    this.getFullInfoByWardId(this.editedItem.address.ward);
                }
            }
        },

        
        methods: {
            formatDate (date) {
                if (!date) {
                    return null
                }
                
                const [year, month, day] = date.split('-')
                return `${day}/${month}/${year}`
            },
            async getProvince() {
                try {
                    // const response =  await this.$http.get('/province');
                    const response =  await this.$http.get(process.env.VUE_APP_VT_PROVINCE_API);
                    if (response.data && response.data.success) {
                        this.provinces = response.data.data;
                        // if (!this.firstEdit) {
                        //     this.selectProvince = this.provinces[0];
                        // }
                    }
                } catch(e) {
                    console.log(e.stack);
                }
            },

            async getDistrictByProvinceID(provinceId) {
                try {
                    // const response =  await this.$http.get('/province/province/' + provinceId);
                    const response =  await this.$http.get(process.env.VUE_APP_VT_DISTRICT_API + provinceId);
                    if (response.data && response.data.success) {
                        this.districts = response.data.data;
                    }
                } catch(e) {
                    console.log(e.stack);
                }
            },

            async getWardByDistrictID(districtId) {
                try {
                    // const response =  await this.$http.get('/province/province/' + provinceId);
                    const response =  await this.$http.get(process.env.VUE_APP_VT_WARD_API + districtId);
                    if (response.data && response.data.success) {
                        this.wards = response.data.data;
                    }
                } catch(e) {
                    console.log(e.stack);
                }
            },

            async getFullInfoByWardId(wardId) {
                try {
                    // const response =  await this.$http.get('/province/province/' + provinceId);
                    const response =  await this.$http.get(process.env.VUE_APP_VT_FULL_INFO_API + wardId);
                    if (response.data && response.data.success) {
                        this.selectProvince = response.data.data.province;
                        this.selectDistrict = response.data.data.district;
                        this.selectWard = response.data.data.ward;

                        setTimeout(() => {this.firstEdit = false}, 200);
                    }
                } catch(e) {
                    console.log(e.stack);
                }
            },
            
            async getJobByCategory(category) {
                const self = this;
                try {
                    const response = await this.$http.get('/job/category/' + category._id);
                    if (response.data && response.data.success) {
                        self.jobs = response.data.data;
                        let findJob = null;

                        if(!self.isAdmin) {
                            self.jobs = self.jobs.filter(item => {
                                if (Array.isArray(item.context.parents) && item.context.parents.length > 0) {
                                    return self.userType == item.context.parents[0].type;
                                } else {
                                    return self.userType == item.context.type;
                                }
                            })
                        }
                        
                        if (self.selectedJob) {
                            findJob = self.jobs.find(item => item._id === self.selectedJob._id)
                        }
                        
                        if (findJob) {
                            self.selectedJob = findJob;
                        } else {
                            self.selectedJob = self.jobs[0];
                        }
                    }
                } catch (e) {
                    console.log(e.stack);
                }
            },

            async getAllCategory() {
                try {
                    const response =  await this.$http.get('/job/categories/0');
                    if(response.data && response.data.success) {
                        this.categories = response.data.data;

                        if (!this.isAdmin) {
                            this.categories = this.categories.filter(item => item.type < this.userCategory);
                        }
                        
                        if (Array.isArray(this.categories) && this.categories.length > 0 && this.editedIndex == -1) {
                            this.selectCategory = this.categories[0];
                        }

                        const optionAll = {
                            title : "Tất cả",
                            _id : "-1"
                        }

                        this.categoriesFilter = [optionAll].concat(this.categories);
                        this.selectCategoryFilter = optionAll;
                    }
                } catch(e) {
                    console.log(e.stack);
                }
            },

            async createUser() {
                this.overlay = true;
                if (this.editedIndex > -1) {
                    const self = this;
                    const requestBody = {};
                    
                    Object.assign(requestBody, self.editedItem);
                    requestBody.birthday = moment(String(this.date)).format("DD/MM/YYYY");
                    requestBody.job = self.selectedJob._id;
                    requestBody.jobs = [];

                    self.editedItem.birthday = this.date;
                    self.editedItem.job = self.selectedJob;
                    console.log(requestBody);
                    try {
                        const response =  await this.$http.put(process.env.VUE_APP_GET_USER_URL + self.editedItem._id, requestBody);

                        console.log(response);
                        if (response.data && !response.data.success) {
                            alert(response.data.message);
                        }
                    } catch(e) {
                        console.log(e.stack);
                        alert(i18n.t('validate.request_error'));
                    }
                } else {
                    const self = this;
                    const requestBody = {};
                    
                    Object.assign(requestBody, self.editedItem);
                    requestBody.birthday = moment(String(this.date)).format("DD/MM/YYYY");
                    requestBody.job = self.selectedJob._id;
                    requestBody.jobs = [];
                    self.editedItem.birthday = this.date;
                    self.editedItem.job = self.selectedJob;

                    console.log(requestBody);

                    try {
                        const response =  await this.$http.post(process.env.VUE_APP_GET_USER_URL, requestBody);
                        if(response.data && response.data.success) {
                            self.editedItem._id = response.data.data.id;    
                            console.log('create new user sucesss!!'); 
                            console.log(self.editedItem);        
                        } else if (response.data && !response.data.success) {
                            alert(response.data.message);
                            this.overlay = false;
                        } else {
                            alert(i18n.t('validate.request_error'));
                            this.overlay = false;
                        }
                    } catch(e) {
                        console.log(e.stack);
                        alert(i18n.t('validate.request_error'));
                    }
                }
            },

            async addAddress() {
                if (!this.selectWard) {
                    alert(i18n.t('validate.ward_empty'));
                    return;
                }

                if (!this.detail) {
                    alert(i18n.t('validate.address_invalid'));
                    return;
                }

                const self = this;
                const fullDetail = self.detail + ", " + self.selectWard.wards_name + ", " + self.selectDistrict.district_name 
                                + ", " + self.selectProvince.province_name
                if (this.editedIndex > -1) {
                    const self = this;
                    const requestBody = {
                        name : self.editedItem.fullname,
                        uid : self.editedItem._id,
                        detail : self.detail,
                        ward : self.selectWard.wards_id,
                        fullDetail: fullDetail
                    };

                    if (self.editedItem.address) {
                        try {
                            const response =  await this.$http.put(process.env.VUE_APP_ADDRESS_API + self.editedItem.address._id, requestBody);
                            this.overlay = false;
                            if (response.data && response.data.success) {
                                self.editedItem.address.fullDetail = fullDetail;
                                self.editedItem.address.ward = self.selectWard.wards_id;
                                self.editedItem.address.detail = self.address;

                                self.detail = '';

                                this.$emit('updateUser', this.editedItem);
                                this.$emit('closeDialog', false);
                            }
                        } catch(e) {
                            console.log(e.stack);
                        }
                    } else {
                        try {
                            const response =  await this.$http.post(process.env.VUE_APP_ADDRESS_API, requestBody);
                            this.overlay = false;
                            if (response.data && response.data.success) {
                                // self.editedItem.address.fullDetail = fullDetail;
                                // self.editedItem.address.ward = self.selectWard.wards_id;
                                // self.editedItem.address.detail = self.detail;

                                self.editedItem.address = {
                                    fullDetail: fullDetail,
                                    ward: self.selectWard.wards_id,
                                    detail: self.detail
                                }

                                self.detail = '';

                                this.$emit('updateUser', this.editedItem);
                                this.$emit('closeDialog', false);
                            } else if (response.data && !response.data.success) {
                                alert(response.data.message);
                                this.overlay = false;
                            } else {
                                alert(i18n.t('validate.request_error'));
                                this.overlay = false;
                            }
                        } catch(e) {
                            console.log(e.stack);
                        }
                    }
                    
                } else {
                    const self = this;
                    const requestBody = {
                        name : self.editedItem.fullname,
                        uid : self.editedItem._id,
                        detail : self.detail,
                        ward : self.selectWard.wards_id,
                        fullDetail: fullDetail
                    };

                    try {
                        const response =  await this.$http.post(process.env.VUE_APP_ADDRESS_API, requestBody);
                        this.overlay = false;
                        if (response.data && response.data.success) {
                            self.editedItem.address = {
                                fullDetail: fullDetail,
                                ward: self.selectWard.wards_id,
                                detail: self.detail
                            }
                            // self.editedItem.address.fullDetail = fullDetail;
                            // self.editedItem.address.ward = self.selectWard.wards_id;
                            // self.editedItem.address.detail = self.detail;

                            self.detail = '';
                            this.$emit('updateUser', this.editedItem);
                            this.$emit('closeDialog', false);
                        } else if (response.data && !response.data.success) {
                            alert(response.data.message);
                        } else {
                            alert(i18n.t('validate.request_error'));
                        }
                    } catch(e) {
                        console.log(e.stack);
                    }
                }  
            },

            
            validateUserInfor() {
                if (!this.editedItem.fullname || this.editedItem.fullname.length == 0) {
                    alert(i18n.t('validate.infor_empty'));
                    return;
                }

                if (!this.editedItem.phone || this.editedItem.phone.length == 0) {
                    alert(i18n.t('validate.infor_empty'));
                    return;
                }

                if (!this.editedItem.email || this.editedItem.email.length == 0) {
                    alert(i18n.t('validate.infor_empty'));
                    return;
                }

                if (!this.editedItem.nickname || this.editedItem.nickname.length < 3) {
                    alert(i18n.t('validate.nickname_invalid'));
                    return;
                }

                if (!this.editedItem.identify || this.editedItem.identify.length == 0) {
                    alert(i18n.t('validate.infor_empty'));
                    return;
                }

                if (!this.date) {
                    alert(i18n.t('validate.infor_empty'));
                    return;
                }

                this.e1 = 2;
            },

            validateAddressInfor() {
                if (!this.selectProvince || !this.selectDistrict || !this.selectDistrict) {
                    alert(i18n.t('validate.infor_empty'));
                    return;
                }

                if (!this.detail || this.detail.length == 0) {
                    alert(i18n.t('validate.infor_empty'));
                    return;
                }

                // this.e1 = 3;
                this.closeDialog();
            },

            back () {
                if (this.e1 > 1) {
                    this.e1 = this.e1 - 1;
                }
            },

            // selectJob(job) {
            //     this.selectedJob = job;
            // },

            async closeDialog() {
                this.e1 = 1;
                await this.createUser();
                await this.addAddress();
            },

            cancelAction() {
                this.e1 = 1;
                this.$emit('closeDialog', false);
            }
        }
    }
</script>

<style scoped>

  .v-text-field .v-input__control .v-input__slot {
    min-height: 45px !important;
    /* display: flex !important; */
    align-items: center !important;
  }
</style>
